import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import { useTranslation } from 'react-i18next';
import EquipmentBelt from './EquipmentBelt';
import { parseEquipmentBelt } from '../utils/equipment';

export default function ShooterInfo({ shooter, showDetails = false, onClick, compact = false }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(showDetails);

  if (!shooter) return null;

  const handleClick = () => {
    if (onClick) {
      onClick(shooter);
    } else {
      setExpanded((prev) => !prev);
    }
  };

  if (compact) {
    return (
      <Chip
        icon={<PersonIcon />}
        label={`${shooter.publicId ? `#${shooter.publicId} ` : ''}${shooter.name}`}
        onClick={handleClick}
        variant="outlined"
        sx={{ maxWidth: 300 }}
      />
    );
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        p: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        cursor: 'pointer',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PersonIcon color="action" />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            {shooter.publicId && <span style={{ color: '#666', marginRight: 4 }}>#{shooter.publicId}</span>}
            {shooter.name}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {[
              shooter.division && t(`divisions.${shooter.division.replace(/-([a-z])/g, (_, c) => c.toUpperCase())}`, shooter.division),
              shooter.category && t(`categories.${shooter.category.replace(/-([a-z])/g, (_, c) => c.toUpperCase())}`, shooter.category),
              shooter.club,
            ].filter(Boolean).join(' | ')}
          </Typography>
        </Box>
      </Box>
      <Collapse in={expanded}>
        <Box sx={{ mt: 1, pl: 4 }}>
          {shooter.squad && (
            <Typography variant="body2" color="text.secondary">
              Squad: {shooter.squad}
            </Typography>
          )}
          {shooter.team && (
            <Typography variant="body2" color="text.secondary">
              Team: {shooter.team}
            </Typography>
          )}
          {shooter['power-factor'] && (
            <Typography variant="body2" color="text.secondary">
              Power Factor: {shooter['power-factor']}
            </Typography>
          )}
          {shooter.email && (
            <Typography variant="body2" color="text.secondary">
              Email: {shooter.email}
            </Typography>
          )}
          {(() => {
            const belt = parseEquipmentBelt(shooter);
            return belt ? <EquipmentBelt equipmentObj={belt} readOnly /> : null;
          })()}
        </Box>
      </Collapse>
    </Box>
  );
}
